export default __webpack_public_path__ + "static/media/nossas_unidades_12.3de52054.webp";